import { Link } from "react-router-dom";
import Seo from "@/components/base/Seo";
import PageHero from "@/components/feature/PageHero";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { values, stats, testimonials } from "@/mocks/stats";

const positions = [
  {
    title: "我们是谁",
    desc: "爆料51 是一个面向全网开放的公众线索征集平台。我们不生产结论，只负责把散落的信息收集起来、梳理清楚、核实下去。",
    icon: "ri-community-line",
  },
  {
    title: "为什么做这件事",
    desc: "很多值得被看见的问题，卡在“没人把它说出来”。我们希望降低提供线索的门槛，让知情者不必承担额外风险，也能让信息找到出口。",
    icon: "ri-lightbulb-flash-line",
  },
  {
    title: "我们坚持什么",
    desc: "真实高于热度，来源保护高于流量。宁可不发，也不传播未经核实的内容；宁可慢一点，也不让提供者暴露在风险里。",
    icon: "ri-anchor-line",
  },
];

export default function About() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "关于我们 - 爆料51",
      url: "https://kunkunedu.cn/about",
      description: "了解爆料51 的平台定位、发展理念、内容原则与来源保护机制。",
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "爆料51",
      url: "https://kunkunedu.cn/",
      email: "tips@baoliao51.com",
      description: "面向全网开放的公众线索征集与悬赏平台，围绕公共议题收集真实、可核实的信息。",
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: "https://kunkunedu.cn/" },
        { "@type": "ListItem", position: 2, name: "关于我们", item: "https://kunkunedu.cn/about" },
      ],
    },
  ];

  return (
    <>
      <Seo
        title="关于我们 | 爆料51 线索征集平台的定位与原则"
        description="了解爆料51 的平台定位、发展理念、内容原则与来源保护机制。我们以真实优先、来源保护、公众价值、理性克制为准则，持续收集可核实的公众线索。"
        keywords="爆料51关于我们,线索征集平台,来源保护,内容原则"
        path="/about"
        jsonLd={jsonLd}
      />
      <PageHero
        eyebrow="关于我们"
        title="把散落的线索，接到一起"
        description="爆料51 相信，很多问题的改变，都始于一条被认真对待的线索。我们的工作，是让这些线索被看见、被核实、被接住。"
        crumbs={[{ label: "关于我们" }]}
      />

      <section className="w-full bg-background-50 py-12 md:py-16" aria-labelledby="brand-intro">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-10 px-4 md:px-8 lg:grid-cols-2 lg:gap-14">
          <Reveal>
            <div className="h-[300px] w-full overflow-hidden rounded-lg border border-background-200 md:h-[440px]">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20editorial%20photograph%20of%20a%20quiet%20investigative%20workspace%20with%20notebooks%2C%20pinned%20documents%20on%20a%20cork%20board%2C%20a%20desk%20lamp%20and%20a%20cup%20of%20tea%2C%20soft%20window%20light%2C%20muted%20amber%20green%20and%20cream%20tones%2C%20careful%20documentary%20still%20life%2C%20no%20people&width=1200&height=900&seq=baoliao51-about-desk-01&orientation=landscape"
                alt="爆料51 线索核实工作场景"
                title="爆料51 线索核实与整理工作"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </Reveal>

          <div>
            <Reveal>
              <SectionHeading
                id="brand-intro"
                eyebrow="平台介绍"
                title="一个认真对待每条线索的征集平台"
                description="爆料51 从一个朴素的判断出发：公众议题的推进，需要有人愿意提供信息，也需要有人愿意为信息负责。我们把这两件事放在同一个流程里。"
              />
            </Reveal>
            <Reveal delay={100}>
              <div className="mt-6 flex flex-col gap-4 text-sm leading-relaxed text-foreground-700 md:text-base">
                <p>
                  平台围绕民生关注、消费维权、环境安全、财经线索等八个方向持续征集。每一条进入流程的线索，
                  都会经过初步评估、对接核实与交叉验证，形成可追溯的记录。
                </p>
                <p>
                  我们同样重视规则。涉及他人隐私且与公共利益无关的内容、缺乏依据的传闻，都不会进入核实流程。
                  我们希望这里的每一条线索，都经得起时间与事实的检验。
                </p>
              </div>
            </Reveal>
            <Reveal delay={160}>
              <dl className="mt-8 grid grid-cols-2 gap-x-4 gap-y-5 border-t border-background-200 pt-6">
                {stats.map((item) => (
                  <div key={item.label}>
                    <dd className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{item.value}</dd>
                    <dt className="mt-1 text-xs text-foreground-600 md:text-sm">{item.label}</dt>
                  </div>
                ))}
              </dl>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="w-full bg-background-100 py-12 md:py-16" aria-labelledby="position-section">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
          <Reveal>
            <SectionHeading
              id="position-section"
              eyebrow="定位与理念"
              title="我们为什么这样做"
              description="平台的方向不是追热点，而是让有价值的信息被认真处理。这决定了我们如何看待线索、如何对待提供者。"
            />
          </Reveal>
          <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
            {positions.map((item, index) => (
              <Reveal key={item.title} delay={index * 80}>
                <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6">
                  <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-50 text-primary-600">
                    <i className={`${item.icon} text-2xl`} />
                  </span>
                  <h3 className="mt-5 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-background-50 py-12 md:py-16" aria-labelledby="value-section">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
          <Reveal>
            <SectionHeading
              id="value-section"
              eyebrow="内容原则"
              title="四条不妥协的底线"
              description="这些原则写在流程里，而不是写在口号里。它们决定了什么样的线索会被接住，什么样的内容会被拒绝。"
            />
          </Reveal>
          <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {values.map((item, index) => (
              <Reveal key={item.title} delay={index * 70}>
                <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${item.icon} text-xl`} />
                  </span>
                  <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-background-100 py-12 md:py-16" aria-labelledby="voice-section">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
          <Reveal>
            <SectionHeading
              id="voice-section"
              eyebrow="用户口碑"
              title="来自提供者与关注者的反馈"
              description="我们更在意流程是否让人安心，而不是把声音放大。以下反馈来自参与过征集流程的用户。"
            />
          </Reveal>
          <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2">
            {testimonials.map((item, index) => (
              <Reveal key={item.name} delay={index * 70}>
                <figure className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6">
                  <i className="ri-double-quotes-l text-2xl text-primary-300" />
                  <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                    {item.content}
                  </blockquote>
                  <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-50 font-heading text-sm font-bold text-primary-600">
                      {item.name.slice(0, 1)}
                    </span>
                    <span>
                      <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                      <span className="block text-xs text-foreground-500">{item.role}</span>
                    </span>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 py-12 md:px-8 md:py-16" aria-label="联系我们">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-start justify-between gap-6 rounded-lg border border-background-200 bg-secondary-50 p-6 md:flex-row md:items-center md:p-10">
          <div>
            <h2 className="font-heading text-xl font-bold text-secondary-900 md:text-2xl">联系我们</h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-secondary-800">
              有线索、有疑问，或想了解征集流程，都可以通过以下方式与我们取得联系。我们会在收到后尽快回复。
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-secondary-900">
              <span className="flex items-center gap-2">
                <i className="ri-mail-line" />
                tips@baoliao51.com
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-time-line" />
                反馈周期：48 小时内
              </span>
            </div>
          </div>
          <Link
            to="/submit"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-megaphone-line" />
            前往提供线索
          </Link>
        </div>
      </section>
    </>
  );
}